import { useAutoneTranslation } from '@autone/translations';
import {
  Separator,
  TooltipContentCard,
  TooltipRoot,
  TooltipTrigger,
} from '@autone/ui-next/atoms';
import { CheckIcon, DotIcon, XIcon } from 'lucide-react';

import { type APP_NAME } from '../../constants';
import { useAssortmentDataFeedStatus } from '../../hooks/data-feed';

export const AssortmentDataFeedTooltip = () => {
  const {
    isAssortmentDataFeedActive,
    isInitialAllocationDataFeedActive,
    isLoading,
  } = useAssortmentDataFeedStatus();
  const { t } = useAutoneTranslation<typeof APP_NAME>();

  if (isLoading) {
    return null;
  }

  if (!isAssortmentDataFeedActive && !isInitialAllocationDataFeedActive) {
    return null;
  }

  return (
    <>
      <DotIcon size={12} />
      <TooltipRoot>
        <TooltipTrigger asChild>
          <div className="flex flex-row gap-1 items-center text-primary-40">
            <p className="text-primary-40 underline">
              {t('new.data-feed.title')}
            </p>
          </div>
        </TooltipTrigger>
        <TooltipContentCard
          align={'start'}
          side={'bottom'}
          className="flex flex-col gap-1 w-[150px] px-2 py-1.5 text-xs"
        >
          <div className="flex flex-row gap-1 items-center">
            <div className="w-1.5 h-1.5 bg-primary rounded-full animate-pulse" />
            <p className="text-primary-100">
              {t('new.data-feed.data-feed-active-for')}
            </p>
          </div>
          <Separator className="-mx-2 !w-[150px]" />
          <ul className="flex flex-col w-full">
            <li className="flex flex-row gap-1 items-center">
              {isAssortmentDataFeedActive ? (
                <CheckIcon size={12} />
              ) : (
                <XIcon size={12} />
              )}
              <p>{t('new.assortment')}</p>
            </li>
            <li className="flex flex-row gap-1 items-center">
              {isInitialAllocationDataFeedActive ? (
                <CheckIcon size={12} />
              ) : (
                <XIcon size={12} />
              )}
              <p>{t('new.initial-allocation')}</p>
            </li>
          </ul>
        </TooltipContentCard>
      </TooltipRoot>
    </>
  );
};
